module.exports = __webpack_public_path__ + "img/automatic-translation.abe3eb8e.png";